<template>
  <div id="app" :class="{ 'in-iframe': isIframe }">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      theme: window.theme,
      isIframe: window.isIframe
    }
  }
}
</script>

<style lang="scss">
@import "assets/style/app";
</style>
<style scoped lang="scss">
[data-theme=light] .in-iframe {
  background-color: #fff !important;
  overflow: hidden !important;
}
</style>
